import { render, staticRenderFns } from "./add-space-admin.vue?vue&type=template&id=3c1d4d9a&"
import script from "./add-space-admin.vue?vue&type=script&lang=ts&"
export * from "./add-space-admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports